import { map } from 'rxjs';
import { createState, dispatch } from 'iblokz-state';
import { patchStream } from 'iblokz-snabbdom-helpers';
import { toVNode } from 'snabbdom';

import ui from './ui';
import i18n from './i18n';

// services
import auth from './services/auth';
import router from './services/router';
import rest from './services/rest';
import resource from './services/resource';

const resources = Object.keys(rest.config.routes.api)
	.filter(route => route !== '_meta');

// Compose full action tree before createState so initial includes all namespaces
let tree = Object.assign({}, require('./actions'), {
	auth: auth.actions,
	router: router.actions
});
tree.initial = Object.assign({}, tree.initial, {themeMode: 'light'});
tree = resources.reduce((t, ns) => resource.attach(t, ns), tree);

const preserved = module.hot && module.hot.data && module.hot.data.state;

let {actions, state$} = createState(tree);
if (preserved) {
	dispatch(() => preserved);
}

const {applyDocumentTheme} = require('./util/theme');
applyDocumentTheme(state$.getValue().themeMode || 'light');

const hookServices = () => {
	auth.hook({state$, actions});
	router.hook({state$, actions});
	rest.hook({state$, actions});
	resources.forEach(resource.hook({state$, actions}));
};

const unhookServices = () => {
	auth.unhook();
	router.unhook();
	rest.unhook();
	resource.unhook();
};

hookServices();

let vnode$ = state$.pipe(map(state => ui({
	state,
	actions,
	i18n: i18n[state.lang] || i18n.bg
})));
let patchSubscription = patchStream(vnode$, toVNode(document.body));

if (module.hot) {
	module.hot.dispose(data => {
		data.state = state$.getValue();
		unhookServices();
		patchSubscription.unsubscribe();
		state$.complete();
	});
	module.hot.accept(() => {
		if (module.hot.data && module.hot.data.state) {
			dispatch(() => module.hot.data.state);
		} else {
			dispatch(state => state);
		}
		actions.ping();
	});
}
